<template>
  <button class="bg-blackly sm:p-2 focus:outline-none p-1" @click="$emit('click')">
    <FullScreen class="hover:scale-110 w-full transform h-12" />
  </button>
</template>

<script>
import FullScreen from '@/components/icons/FullScreen.vue'
export default {
  components: {
    FullScreen
  }
}
</script>
